import React, { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { AuthContext } from "./context/auth";
import firebase from "./firebase.js";
import { isMobile, isIOS, isChrome } from "react-device-detect";
import { useTranslation, I18nextProvider } from "react-i18next";

import { createGlobalStyle } from "styled-components";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { StylesProvider } from "@material-ui/core/styles";

import PrivateRoute from "./PrivateRoute";
import Login from "./components/Login";
import CharacterReveal from "./components/CharacterReveal/CharacterReveal";
import MainPage from "./components/MainPage/MainPage";
import BrowserErrorPage from "./components/ErrorPage/BrowserErrorPage";
import IosChromeErrorPage from "./components/ErrorPage/IosChromeErrorPage";
import LanguageButton from "./components/LanguageButton";

firebase.analytics();

const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    font-family: 'Nunito', sans-serif;
  }
`;

const theme = createMuiTheme({
    typography: {
        fontFamily: `"Nunito", sans-serif`,
    },
});

const App = (props) => {
    const existingTokens = JSON.parse(localStorage.getItem("tokens"));
    const { i18n } = useTranslation();
    const [authTokens, setAuthTokens] = useState(existingTokens);
    const [anchorEl, setAnchorEl] = useState(null);
    let initialIndex;
    i18n.language === "zh" ? (initialIndex = 0) : (initialIndex = 1);
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);

    const setTokens = (data) => {
        localStorage.setItem("tokens", JSON.stringify(data));
        setAuthTokens(data);
    };

    const handleLang = (e, index) => {
        if (index === 0) {
            const lang = "zh";
            i18n.changeLanguage(lang);
        } else {
            const lang = "en";
            i18n.changeLanguage(lang);
        }
        setSelectedIndex(index);
        setAnchorEl(null);
    };

    const handleMenuClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    if (isMobile) {
        if (isIOS && isChrome) {
            return (
                <>
                    <GlobalStyle />
                    <IosChromeErrorPage />
                </>
            );
        }
        return (
            <AuthContext.Provider
                value={{ authTokens, setAuthTokens: setTokens }}
            >
                <I18nextProvider i18n={i18n}>
                    <Router>
                        <Switch>
                            <MuiThemeProvider theme={theme}>
                                <StylesProvider injectFirst>
                                    <GlobalStyle />
                                    {/* <Route
                                        exact
                                        path="/login"
                                        component={Login}
                                    /> */}
                                    <PrivateRoute
                                        exact
                                        path="/character/:characterName?/mainpage"
                                        component={MainPage}
                                    />
                                    <PrivateRoute
                                        exact
                                        path="/character/:characterName?"
                                        component={CharacterReveal}
                                    />
                                    <Route
                                        exact
                                        path="/"
                                        component={() => {
                                            window.location.href =
                                                "https://hojengar.page.link/download";
                                            return null;
                                        }}
                                    />
                                </StylesProvider>
                            </MuiThemeProvider>
                        </Switch>
                    </Router>
                    {/* <div style={{ position: "absolute", top: 0, left: 0 }}>
                        V 0.1.12
                    </div> */}
                    <StylesProvider injectFirst>
                        <GlobalStyle />
                        <LanguageButton
                            handleMenuClick={handleMenuClick}
                            anchorEl={anchorEl}
                            handleClose={handleClose}
                            handleLang={handleLang}
                            selectedIndex={selectedIndex}
                        />
                    </StylesProvider>
                </I18nextProvider>
            </AuthContext.Provider>
        );
    }
    return (
        <>
            <GlobalStyle />
            <BrowserErrorPage />
        </>
    );
};

export default App;
